import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, DatePicker, Form, Input, Select, Spin, Table } from "antd";
import { ReadCookie } from "../../utils/readCookie";
import numeral from "numeral";
import moment from "moment";
import logo from "../../assets/images/logo.png";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import "../ProducList/productList.css";
import { TabTitle } from "../../utils/GeneralFunction.js";
import { useDownloadExcel } from "react-export-table-to-excel";
import Loader from "react-spinners/BarLoader.js";
import { loadCustomers } from "../../redux/actions/customerForm.js";
import { getRegion } from "../../redux/actions/region.action.js";
import { getGender } from "../../redux/actions/gender.action.js";
import { getPaymentTerm } from "../../redux/actions/paymentterm.action.js";
import { getAllCompany } from "../../redux/actions/companyAccess.js";
import { loadSalePerson } from "../../redux/actions/salePerson/salePersonForm.action.js";
import { getFactor } from "../../redux/actions/factor.action.js";
import { getArAgingSummary } from "../../redux/actions/arAgingSummary.action.js";
import { generateDynamicPDF } from "../../utils/generateDynamicPDF.js";
import 'jspdf-autotable';
import ExcelJS from "exceljs";
import { Link } from "react-router-dom/cjs/react-router-dom.min.js";
import { CSVLink } from "react-csv";
import csv from "../../assets/images/csv.png";
import pdf from "../../assets/images/PDF_file_icon.svg.png";

const ArAgingSummaryNew = ({ token }) => {
  TabTitle("AR Aging Summary")
  const userName = ReadCookie("name");
  const menuId = ReadCookie("menuId");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  const [loading, setLoading] = useState(false);
  const tableRef = useRef(null);
  const { gender, salePersonForm, paymentterm, customerForms, arAgingSummary, factor } = useSelector((state) => state);
  const [customer, setCustomer] = useState("All");
  const [excelData, setExcelData] = useState([])

  const { onDownload: onDownloadReport } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Dropship Summary",
    sheet: "Sheet 1",
  });

  const groupedData = arAgingSummary?.payload?.data?.reduce((acc, item) => {
    if (!acc[item.customer_id]) {
      acc[item.customer_id] = {
        name: item.customer_name,
        data: []
      };
    }
    acc[item.customer_id].data.push(item);
    return acc;
  }, {}) || {};

  console.log("groupedData", groupedData)


  const onFinish = async () => {
    setLoading(true);
    await form.validateFields().then((values) => {
      dispatch(getArAgingSummary(token, values)).then((res) => {
        setLoading(false);
        downloadExcelFileData(res?.payload?.data);
      });
    }).catch((error) => {
      setLoading(false);
    })
  }

  const handlePrint = () => {
    const css = '@page { margin-top: 25px; margin-bottom: 25px; margin-right: 0px; padding: 0px}';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style);
  };

  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'index',

      render: (text, record, index) => {
        return index + 1;
      },
      width: 40,
    },
    {
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer_name",
      width: 220,
      render: (text, record) => {
        return <Link
          style={{ color: "blue", textDecoration: "underline", padding: "10px", textDecoration: "none" }}
          target="_blank"
          rel="noopener noreferrer"
          to={{ pathname: `/customer-payment-ledger`, search: `?customer_id=${record?.customer_id}&customer_name=${record?.customer_name}` }}
        >{record.customer_name}
        </Link>
      },
    },
    {
      title: "SalesPerson",
      dataIndex: "sales_person",
      key: "sales_person",
      width: 120,
    },
    {
      title: "Gender",
      dataIndex: "gender_name",
      key: "gender_name",
      width: 100,
    },
    {
      title: "Current",
      dataIndex: "current_balance",
      key: "current_balance",
      render: (text, record) => {
        return <>${record.sales_person === "Credits" ? 0.00 : numeral(record.current_balance).format("0,00.00")}
        </>
      },
      align: "right",
      width: 90,
    },

    {
      title: "1-30 Days",
      dataIndex: "one_to_thirty",
      key: "one_to_thirty",
      render: (text, record) => {
        return <>$ {numeral(text).format("0,00.00")}</>
      },
      align: "right",
      width: 90,
    },
    {
      title: "31-60 Days",
      dataIndex: "thirty_to_sixty",
      key: "thirty_to_sixty",
      render: (text, record) => {
        return <>$ {numeral(text).format("0,00.00")}</>
      },
      align: "right",
      width: 90,
    },
    {
      title: "61-90 Days",
      dataIndex: "sixty_to_ninety",
      key: "sixty_to_ninety",
      render: (text, record) => {
        return <>$ {numeral(text).format("0,00.00")}</>
      },
      align: "right",
      width: 90,
    },
    {
      title: "> 90 Days",
      dataIndex: "greter_than_ninety",
      key: "greter_than_ninety",
      render: (text, record) => {
        return <>$ {numeral(text).format("0,00.00")}</>
      },
      align: "right",
      width: 90,
    },
    {
      title: "Total",
      dataIndex: "totalbalance",
      key: "totalbalance",
      render: (text, record) => {
        return <>$ {record.sales_person === "Credits" ? 0.00 : numeral(record.totalbalance).format("0,00.00")}</>
      },
      align: "right",
      width: 90,
    },
    {
      title: "Available Credit",
      dataIndex: "available_credit",
      key: "available_credit",
      render: (text, record) => {
        return <>$ {numeral(text).format("0,00.00")}</>
      },
      align: "right",
      width: 100,
    },
    {
      title: "Net",
      dataIndex: "netbalance",
      key: "netbalance",
      render: (text, record) => {
        return <>$ {numeral(text).format("0,00.00")}</>
      },
      align: "right",
      width: 90,
    },

  ];

  function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const handleChanges = (val) => {
    if (val === "" || val === "All") return;
    setCustomer(val);
    dispatch(loadCustomers(token, null, null, null, null, null, val, null, null, null, null, null, null, null, null, null, null, null, null)).then(
      (res) => {
        if (res?.type === "GET_ALL_CUSTOMERS_SUCCESS") {
          setCustomer(res?.payload?.data);
        }
      }
    );
  };

  const optimizedFn = useCallback(debounce(handleChanges), []);

  useEffect(() => {
    dispatch(getRegion(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getPaymentTerm(token, menuId));
    dispatch(getAllCompany(token));
    dispatch(loadSalePerson(token));
    dispatch(getFactor(token, menuId));
  }, [dispatch, menuId, token]);

  function downloadExcelFileData(data) {
    setExcelData(
      data.map((v) => {
        return {
          "Customer": v.customer_name,
          "SalesPerson": v.sales_person,
          "Gender": v.gender_name,
          "Current": `$ ${numeral(v.current_balance).format("0,00.00")}`,
          "1-30 Days": `$ ${numeral(v.one_to_thirty).format("0,00.00")}`,
          "31-60 Days": `$ ${numeral(v.thirty_to_sixty).format("0,00.00")}`,
          "61-90 Days": `$ ${numeral(v.sixty_to_ninety).format("0,00.00")}`,
          "> 90 Days": `$ ${numeral(v.greter_than_ninety).format("0,00.00")}`,
          "Total": `$ ${numeral(v.totalbalance).format("0,00.00")}`,
          "Available Credit": `$ ${numeral(v.available_credit).format("0,00.00")}`,
          "Net": `$ ${numeral(v.netbalance).format("0,00.00")}`,
        };
      })
    )
  }

  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();

    // ✅ sanitize sheet name (remove invalid characters)
    const sanitizeSheetName = (name) =>
      name.replace(/[*?:\\/[\]]/g, "-").substring(0, 31); // Excel max length = 31

    const worksheet = workbook.addWorksheet(sanitizeSheetName("A/R Aging Summary"));

    const tableHeaders = [
      "Customer",
      "SalesPerson",
      "Gender",
      "Current",
      "1-30 Days",
      "31-60 Days",
      "61-90 Days",
      "> 90 Days",
      "Total",
      "Available Credit",
      "Net",
    ];

    Object.entries(groupedData).forEach(([customerId, group]) => {
      // 🔹 Empty Row + Group Heading Row
      worksheet.addRow([]);
      const headingRow = worksheet.addRow([group?.name]);
      headingRow.font = { bold: true, size: 14 };
      headingRow.alignment = { horizontal: "left" };
      worksheet.mergeCells(`A${headingRow.number}:K${headingRow.number}`);

      // 🔹 Table Header Row
      const headerRow = worksheet.addRow(tableHeaders);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell, colNumber) => {
        if (colNumber <= 3) {
          cell.alignment = { horizontal: "left" };
        } else {
          cell.alignment = { horizontal: "right" };
        }
      });

      // ✅ Start row for group table
      const startRow = headerRow.number;

      // 🔹 Add group data rows
      group.data.forEach((item) => {
        const row = worksheet.addRow([
          item.customer_name,
          item.sales_person,
          item.gender_name,
          "$" + item.current_balance,
          "$" + item.one_to_thirty,
          "$" + item.thirty_to_sixty,
          "$" + item.sixty_to_ninety,
          "$" + item.greter_than_ninety,
          "$" + item.totalbalance,
          "$" + item.available_credit,
          "$" + item.netbalance,
        ]);

        row.eachCell((cell, colNumber) => {
          if (colNumber <= 3) {
            cell.alignment = { horizontal: "left" };
          } else {
            cell.alignment = { horizontal: "right" };
          }
        });
      });

      // 🔹 Calculate summary
      let current = 0,
        onetoThirty = 0,
        toSixty = 0,
        toNinety = 0,
        greaterNinety = 0,
        total = 0,
        availableCredit = 0,
        net = 0;

      group.data.forEach((item) => {
        const currentVal = item.sales_person === "Credits" ? 0 : parseFloat(item.current_balance || 0);
        const totalVal = item.sales_person === "Credits" ? 0 : parseFloat(item.totalbalance || 0);

        current += currentVal;
        onetoThirty += parseFloat(item.one_to_thirty || 0);
        toSixty += parseFloat(item.thirty_to_sixty || 0);
        toNinety += parseFloat(item.sixty_to_ninety || 0);
        greaterNinety += parseFloat(item.greter_than_ninety || 0);
        total += totalVal;
        availableCredit += parseFloat(item.available_credit || 0);
        net += parseFloat(item.netbalance || 0);
      });

      // 🔹 Add summary row
      const summaryRow = worksheet.addRow([
        "", "", "Total",
        current,
        onetoThirty,
        toSixty,
        toNinety,
        greaterNinety,
        total,
        availableCredit,
        net,
      ]);
      summaryRow.font = { bold: true };
      summaryRow.eachCell((cell, colNumber) => {
        if (colNumber <= 3) {
          cell.alignment = { horizontal: "left" };
        } else {
          cell.alignment = { horizontal: "right" };
        }
      });

      // ✅ End row for group table
      const endRow = summaryRow.number;

      // ✅ Apply border to ALL cells inside the group (grid style)
      for (let row = startRow; row <= endRow; row++) {
        for (let col = 1; col <= 11; col++) {
          const cell = worksheet.getCell(row, col);
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
        }
      }

      // 🔹 Format numeric columns as currency
      for (let col = 4; col <= 11; col++) {
        worksheet.getColumn(col).numFmt = '"$"#,##0.00;[Red]\-"$"#,##0.00';
      }
    });

    // Download Excel
    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "A-R-Aging-Summary.xlsx";
      link.click();
    } catch (error) {
      console.error(error);
    }
  };


  const generatePDF = () => {
    const columns = [
      "#", "Customer", "SalesPerson", "Gender", "Current", "1-30 Days",
      "31-60 Days", "61-90 Days", "> 90 Days", "Total",
      "Available Credit", "Net"
    ];

    const rows = [];
    const sortedData = arAgingSummary?.payload?.data || [];

    sortedData.forEach((item, index) => {
      const row = [
        index + 1,
        item.customer_name,
        item.sales_person,
        item.gender_name,
        "$" + numeral(item.current_balance).format("0,00.00"),
        "$" + numeral(item.one_to_thirty).format("0,00.00"),
        "$" + numeral(item.thirty_to_sixty).format("0,00.00"),
        "$" + numeral(item.sixty_to_ninety).format("0,00.00"),
        "$" + numeral(item.greter_than_ninety).format("0,00.00"),
        "$" + numeral(item.totalbalance).format("0,00.00"),
        "$" + numeral(item.available_credit).format("0,00.00"),
        "$" + numeral(item.netbalance).format("0,00.00")
      ];
      rows.push(row);
    });

    generateDynamicPDF({
      filename: "A-R-Aging-Summary.pdf",
      columns,
      rows,
      rowsRaw: sortedData,
      totalFields: [
        'current_balance',
        'one_to_thirty',
        'thirty_to_sixty',
        'sixty_to_ninety',
        'greter_than_ninety',
        'totalbalance',
        'available_credit',
        'netbalance'
      ],
      currencyFields: [
        'current_balance',
        'one_to_thirty',
        'thirty_to_sixty',
        'sixty_to_ninety',
        'greter_than_ninety',
        'totalbalance',
        'available_credit',
        'netbalance'
      ],
      totalFieldIndexes: {
        current_balance: 4,
        one_to_thirty: 5,
        thirty_to_sixty: 6,
        sixty_to_ninety: 7,
        greter_than_ninety: 8,
        totalbalance: 9,
        available_credit: 10,
        netbalance: 11,
      },
      totalLabel: 'Total:',
      totalLabelIndex: 3, // Under "Gender" column
      rightAlignIndexes: [4, 5, 6, 7, 8, 9, 10, 11], // Align numeric columns to right
      margin: { top: 2, left: 5, right: 5, bottom: 2 }
    });
  };

  const grandTotals = Object.values(groupedData).reduce((acc, group) => {
    group.data.forEach(item => {
      const currentVal = item.sales_person === "Credits" ? 0 : parseFloat(item.current_balance || 0);
      const totalVal = item.sales_person === "Credits" ? 0 : parseFloat(item.totalbalance || 0);

      acc.current += currentVal;
      acc.onetoThirty += parseFloat(item.one_to_thirty || 0);
      acc.toSixty += parseFloat(item.thirty_to_sixty || 0);
      acc.toNinety += parseFloat(item.sixty_to_ninety || 0);
      acc.greaterNinety += parseFloat(item.greter_than_ninety || 0);
      acc.total += totalVal;
      acc.availableCredit += parseFloat(item.available_credit || 0);
      acc.net += parseFloat(item.netbalance || 0);
    });
    return acc;
  }, {
    current: 0, onetoThirty: 0, toSixty: 0, toNinety: 0,
    greaterNinety: 0, total: 0, availableCredit: 0, net: 0
  });

  const formatNumber = (num) =>
    num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="report-wrapper-main header_class">
              <div className="row justify-content-between business_class_oms distributor distributor2">
                <div className="col-3 d-flex align-items-start  box-space">
                  <div className="logobrand">
                    <img id="ImgLogo" alt="logo" src={logo} />
                  </div>
                </div>
                <div className="col-3 box-space right-content-header text-right">
                  <div className=" d-flex justify-content-end">
                    <div className=" d-flex justify-content-end printing_class">
                      <div className="print_icon printing_class">
                        <i
                          id="Image1"
                          title="Print"
                          alt="Print"
                          className="fa-solid fa-print printing_class"
                          onClick={handlePrint}
                        ></i>
                      </div>
                      <div className="print_icon printing_class" >
                        <CSVLink
                          filename={"A/R-Aging-Summary.csv"}
                          data={excelData}
                        >
                          <input
                            type="image"
                            name="ImgCSV"
                            alt="Export to CSV"
                            id="ImgCSV"
                            title="Export to CSV"
                            src={csv}
                            style={{ borderWidth: "0px", height: "24px", float: "inline-end", margin: "12px" }}
                          />
                        </CSVLink>
                      </div>
                      <div className="print_icon printing_class" >
                        <input
                          type="image"
                          name="ImgExcel"
                          alt="Export to Excel"
                          id="ImgExcel"
                          title="Export to Excel"
                          src={xlsx}
                          onClick={exportToExcel}
                          style={{ borderWidth: "0px", height: "14px" }}
                        />
                      </div>
                      <div className="print_icon printing_class" >
                        <input
                          type="image"
                          name="ImgPDF"
                          alt="Export to PDF"
                          id="ImgPDF"
                          title="Export to PDF"
                          src={pdf}
                          onClick={generatePDF}
                          style={{ borderWidth: "0px", height: "18px" }}
                        />
                      </div>
                    </div>
                    <span style={{ fontWeight: "bolder" }}>
                      AR Aging Summary
                      <br />
                      Rpt # 006
                      <br />
                      Login as:
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {" "}
                        {userName}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="row pb-2">
                <div className="col">
                  <Form
                    layout="horizontal"
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                  >
                    <div className="main_form row">
                      <hr className="my-1" />
                      <div className="col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="gender_id" className="labels width30">
                            Gender:
                          </label>
                          <div style={{ marginBottom: "-2px" }} className=" w-100">
                            <Form.Item
                              name="gender"
                              className="formFullWidth"
                              initialValue={"All"}
                            >
                              <Select
                                size='small'
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, options) => options.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                className="styleInput w-100"
                                defaultValue={form.getFieldValue().region}
                                filterSort={(optionA, optionB) =>
                                  optionB?.value !== null ?
                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                }
                              >
                                <Option value={null}>All</Option>
                                {
                                  gender?.payload?.data.map((val) => {
                                    return (
                                      <Option key={val.gender_id} value={val.gender_id}>{val.gender_name}</Option>
                                    )
                                  })
                                }
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className=" col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="gender_id" className="labels width30">
                            Sale Person:
                          </label>
                          <div style={{ marginBottom: "-2px" }} className=" w-100">
                            <Form.Item
                              name="sale_person"
                              className="formFullWidth"
                              initialValue={"All"}
                            >
                              <Select
                                size='small'
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, options) => options.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                className="styleInput w-100"
                                defaultValue={form.getFieldValue().sale_person}
                                filterSort={(optionA, optionB) =>
                                  optionB?.value !== null ?
                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                }
                              >
                                <Option value={null}>All</Option>
                                <Option value={"-1"}>Credit</Option>
                                {
                                  salePersonForm?.payload?.data.map((val, index) => {
                                    return (
                                      <Option key={val.sales_person_id} value={val.sales_person_id}>{val.salesperson_name}</Option>
                                    )
                                  })
                                }

                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className=" col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label className="labels width30">Till Date:</label>
                          <div style={{ marginBottom: "-2px" }} className=" w-100">
                            <Form.Item
                              name="to_date"
                              initialValue={moment().endOf('year')}
                            >
                              <DatePicker
                                size='small'
                                className="styleInput w-100"
                                format={"MM-DD-YYYY"}
                                defaultValue={moment().format("MM-DD-YYYY")}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="main_form row">
                      <div className="col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="gender_id" className="labels width30">
                            Customer:
                          </label>
                          <div style={{ marginBottom: "-2px" }} className=" w-100">
                            <Form.Item
                              name="customer_id"
                              className="formFullWidth"
                              initialValue={"All"}
                            >
                              <Select
                                notFoundContent={
                                  customerForms.loading ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Loader
                                        type="Oval"
                                        color="#3c4b58"
                                        height={20}
                                        width={20}
                                      />
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        textAlign: "center",
                                      }}
                                    >
                                      No Data
                                    </div>
                                  )
                                }
                                className="styleInput w-100"
                                autoComplete={"nope"}
                                allowClear
                                size="small"
                                showSearch
                                optionFilterProp="children"
                                loading={customerForms.loading}

                                defaultValue={form.getFieldValue().customer}
                                placeholder="Select Customer"
                                onSearch={(value) => {
                                  optimizedFn(value);
                                }}
                              >
                                <Option value="All">All</Option>
                                {customerForms?.payload?.data.map(
                                  (item) => {
                                    return (
                                      <Option
                                        defaultValue={"All"}
                                        key={item.customer_id}
                                        value={item.customer_id}
                                      >
                                        {" "}
                                        {`${item.customer_code} - ${item.customer_name}`}
                                      </Option>
                                    );
                                  }
                                )}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className=" col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="gender_id" className="labels width30">
                            Term:
                          </label>
                          <div style={{ marginBottom: "-2px" }} className=" w-100">
                            <Form.Item
                              name="terms"
                              className="formFullWidth"
                              initialValue={"All"}
                            >
                              <Select
                                size='small'
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, options) => options.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                className="styleInput w-100"
                                defaultValue={form.getFieldValue().terms}
                                filterSort={(optionA, optionB) =>
                                  optionB?.value !== null ?
                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                }
                              >
                                <Option value={null}>All</Option>
                                {
                                  paymentterm?.payload?.data.map((val) => {
                                    return (
                                      <Option value={val.term_id}>{val.term_name}</Option>
                                    )
                                  })
                                }

                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className=" col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label className="labels width30">Payment Class:</label>
                          <div style={{ marginBottom: "-2px" }} className=" w-100">
                            <Form.Item
                              name="paymentClass"
                              className="formFullWidth"
                              initialValue={"All"}
                            >
                              <Select
                                size="small"
                                autoComplete={"nope"}
                                className="styleInput w-100"
                                filterOption={(input, option) => option?.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0}
                                showSearch
                                allowClear
                                loading={factor.loading}
                              >
                                {factor?.payload?.data.map(
                                  (item) => {
                                    return (
                                      <Select.Option
                                        key={item.factor_id}
                                        value={item.factor_id}
                                      >
                                        {item.factor_name}
                                      </Select.Option>
                                    );
                                  }
                                )}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div style={{ marginTop: "3px", display: "flex", justifyContent: "right" }} >
                          <Button type="primary" htmlType="submit" className='submit-btn-btm m-0' disabled={loading}>
                            Search
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table_content ar_aging_summary_table_content"
        style={{ width: '1300px' }}
        ref={tableRef} >
        <div>
          {loading ? (
            <div className="d-flex align-items-center justify-content-center spin-style mt-3">
              <Spin />
            </div>
          ) : arAgingSummary?.payload?.data.length ? (
            // Loop through each state group and render a table
            Object.entries(groupedData).map(([customerId, group], index, arr) => (
              <div key={customerId} style={{ marginBottom: "13px" }}>
                <h3 style={{ borderBottom: "1px solid black", paddingBottom: "1px", display: "inline-block", marginTop: "8px" }}>
                  {group?.name}
                </h3>
                <Table
                  size="small"
                  bordered={false}
                  type="company"
                  style={{ fontSize: '10.3px' }}
                  className="border-line-th bottom-align-th table-td-border-right th-general-style td-general-style border omsTable"
                  dataSource={group.data}
                  columns={columns}
                  loading={arAgingSummary.loading}
                  pagination={false}
                  summary={(pageData) => {
                    let current = 0, onetoThirty = 0, toSixty = 0, toNinety = 0, greaterNinety = 0, total = 0, availableCredit = 0, net = 0;

                    pageData.forEach(item => {
                      // Credits condition
                      const currentVal = item.sales_person === "Credits" ? 0 : parseFloat(item.current_balance || 0);
                      const totalVal = item.sales_person === "Credits" ? 0 : parseFloat(item.totalbalance || 0);

                      current += currentVal;
                      onetoThirty += parseFloat(item.one_to_thirty || 0);
                      toSixty += parseFloat(item.thirty_to_sixty || 0);
                      toNinety += parseFloat(item.sixty_to_ninety || 0);
                      greaterNinety += parseFloat(item.greter_than_ninety || 0);
                      total += totalVal;
                      availableCredit += parseFloat(item.available_credit || 0);
                      net += parseFloat(item.netbalance || 0);
                    });

                    const formatNumber = (num) =>
                      num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

                    return (
                      <Table.Summary.Row>
                        <Table.Summary.Cell></Table.Summary.Cell>
                        <Table.Summary.Cell></Table.Summary.Cell>
                        <Table.Summary.Cell></Table.Summary.Cell>
                        <Table.Summary.Cell></Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {formatNumber(current)}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {formatNumber(onetoThirty)}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {formatNumber(toSixty)}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {formatNumber(toNinety)}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {formatNumber(greaterNinety)}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {formatNumber(total)}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {formatNumber(availableCredit)}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {formatNumber(net)}
                          </p>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    );
                  }}
                />
                {index === arr.length - 1 && (
                  <Table
                    size="small"
                    bordered={false}
                    pagination={false}
                    showHeader={false}
                    dataSource={[]}
                    columns={columns}
                    locale={{ emptyText: () => null }}
                    summary={() => (
                      <Table.Summary.Row>
                        <Table.Summary.Cell colSpan={4}>
                          <b>Grand Total</b>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {formatNumber(grandTotals.current)}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {formatNumber(grandTotals.onetoThirty)}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {formatNumber(grandTotals.toSixty)}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {formatNumber(grandTotals.toNinety)}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {formatNumber(grandTotals.greaterNinety)}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {formatNumber(grandTotals.total)}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {formatNumber(grandTotals.availableCredit)}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            $ {formatNumber(grandTotals.net)}
                          </p>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    )}
                  />

                )}
              </div>
            ))
          ) : (
            <div
              style={{
                backgroundColor: '#CCCCCC',
                borderWidth: '1pt',
                borderStyle: 'Dashed',
                fontWeight: 'bold',
                height: '25px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              No record(s)
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ArAgingSummaryNew;

